import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import Login from "./pages/auth/Login";
// Import admin components
import Records from "./pages/admin/Records";
import EmbryoDetails from "./pages/admin/EmbryoDetails";
import EmbryoImages from "./pages/admin/EmbryoImages";
import GeriEmbryos from "./pages/admin/GeriEmbryos";
import GeriEmbryoImages from "./pages/admin/GeriEmbryoImages";

// Protected Route Component
const ProtectedRoute: React.FC<{
  children: React.ReactNode;
  allowedRoles?: string[];
}> = ({ children, allowedRoles }) => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // if (allowedRoles && !allowedRoles.includes(user.role)) {
  //   return <Navigate to="/unauthorized" replace />;
  // }

  return <>{children}</>;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />

          {/* Admin Routes */}
          <Route
            path="/records"
            element={
              <ProtectedRoute allowedRoles={["Admin"]}>
                <Records />
              </ProtectedRoute>
            }
          />
          <Route
            path="/embryos/:id"
            element={
              <ProtectedRoute allowedRoles={["Admin"]}>
                <EmbryoDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/embryo-images/:sample_uuid"
            element={
              <ProtectedRoute allowedRoles={["Admin"]}>
                <EmbryoImages />
              </ProtectedRoute>
            }
          />

          <Route
            path="/geri/embryos/:session_uuid"
            element={
              <ProtectedRoute allowedRoles={["Admin"]}>
                <GeriEmbryos />
              </ProtectedRoute>
            }
          />
          <Route
            path="/geri/embryo-images/:session_uuid/:well_number"
            element={
              <ProtectedRoute allowedRoles={["Admin"]}>
                <GeriEmbryoImages />
              </ProtectedRoute>
            }
          />

          {/* Default Route */}
          <Route path="/" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
